import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MobileTopTabs from "../components/MobileTopTabs";
import "../styles/contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      // Formspree kullanarak e-posta gönderme
      const response = await fetch("https://formspree.io/f/manbjbvp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>_contact-me | Mert Arinci | Full-Stack Developer</title>
        <meta
          name="description"
          content="Get in touch with Mert Arinci, Full-Stack Developer in Rotterdam, Netherlands. Available for freelance projects, collaborations, and full-time opportunities. Contact via email or phone."
        />
        <meta
          name="keywords"
          content="Contact Mert Arinci, Hire Full-Stack Developer, Rotterdam Developer Contact, JavaScript Developer Available, Freelance Developer Netherlands"
        />
        <link rel="canonical" href="https://arinci.nl/contact" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Contact Me - Mert Arinci | Full-Stack Developer"
        />
        <meta
          property="og:description"
          content="Get in touch with Mert Arinci for freelance projects, collaborations, and full-time opportunities. Based in Rotterdam, Netherlands."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://arinci.nl/contact" />
        <meta property="og:site_name" content="Mert Arinci Portfolio" />
        <meta
          property="og:image"
          content="https://arinci.nl/og-image-contact.jpg"
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Contact Mert Arinci | Full-Stack Developer"
        />
        <meta
          name="twitter:description"
          content="Get in touch with Mert Arinci for web development projects and collaborations."
        />

        <meta name="robots" content="index, follow" />

        {/* JSON-LD Structured Data for Contact */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            mainEntity: {
              "@type": "Person",
              name: "Mert Arinci",
              jobTitle: "Full-Stack Developer",
              telephone: "+31616150171",
              email: "mertarinci96@gmail.com",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Rotterdam",
                addressCountry: "Netherlands",
              },
              contactPoint: {
                "@type": "ContactPoint",
                telephone: "+31616150171",
                contactType: "Business",
                availableLanguage: ["English", "Turkish"],
                areaServed: "NL",
              },
              offers: {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Full-Stack Web Development",
                  description:
                    "Custom web application development using modern technologies",
                },
              },
            },
          })}
        </script>
      </Helmet>
      <div id="contact-page">
        <Navbar activePage={"contact"} />

        <div className="contact-content">
          <div className="contact-left">
            <div className="contact-header">
              <p className="subheader">Get in touch</p>
              <h1 className="main-header">_contact-me</h1>
              <p className="function-header">{">"} Let's work together</p>
            </div>

            <div className="contact-info">
              <div className="info-section">
                <span className="gray-text">// contact details</span>
                <div className="contact-details">
                  <p className="code-line">
                    <span className="purple-text">const</span>{" "}
                    <span className="function-text">contactInfo</span> = {"{"}
                  </p>
                  <p className="code-line indent">
                    <span className="light-header-text">email</span>:{" "}
                    <a
                      href="mailto:mertarinci96@gmail.com"
                      className="string-color-text"
                    >
                      "mertarinci96@gmail.com"
                    </a>
                    ,
                  </p>
                  <p className="code-line indent">
                    <span className="light-header-text">phone</span>:{" "}
                    <a href="tel:+31616150171" className="number-color-text">
                      "+31 616 15 01 71"
                    </a>
                    ,
                  </p>
                  <p className="code-line indent">
                    <span className="light-header-text">location</span>:{" "}
                    <span className="string-color-text">
                      "Rotterdam, Netherlands"
                    </span>
                    ,
                  </p>
                  <p className="code-line indent">
                    <span className="light-header-text">linkedIn</span>:{" "}
                    <a
                      href="https://linkedin.com/in/mert-arinci-7536ab26a/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="string-color-text"
                    >
                      "linkedin.com/in/mert-arinci"
                    </a>
                    ,
                  </p>
                  <p className="code-line">{"}"}</p>
                </div>
              </div>

              <div className="info-section">
                <span className="gray-text">// availability</span>
                <div className="availability-info">
                  <p className="code-line">
                    <span className="purple-text">const</span>{" "}
                    <span className="function-text">availability</span> = {"{"}
                  </p>

                  <p className="code-line indent">
                    <span className="light-header-text">responseTime</span>:{" "}
                    <span className="string-color-text">"Within 24 hours"</span>
                    ,
                  </p>
                  <p className="code-line indent">
                    <span className="light-header-text">preferredContact</span>:{" "}
                    <span className="string-color-text">
                      "Email or LinkedIn"
                    </span>
                    ,
                  </p>
                  <p className="code-line">{"}"}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <div className="form-container">
              <div className="form-header">
                <span className="gray-text">// send message</span>
              </div>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">
                    <span className="purple-text">const</span>{" "}
                    <span className="light-header-text">senderName</span> =
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder='"Your Name"'
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    <span className="purple-text">const</span>{" "}
                    <span className="light-header-text">senderEmail</span> =
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder='"your.email@example.com"'
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject" className="form-label">
                    <span className="purple-text">const</span>{" "}
                    <span className="light-header-text">messageSubject</span> =
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder='"Subject of your message"'
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    <span className="purple-text">const</span>{" "}
                    <span className="light-header-text">messageContent</span> =
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="form-textarea"
                    rows="6"
                    placeholder='"Your message here..."'
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="submit-btn"
                >
                  {isSubmitting ? "Sending..." : "sendMessage()"}
                </button>

                {submitStatus === "success" && (
                  <div className="status-message success">
                    <span className="light-header-text">✓</span> Message sent
                    successfully!
                  </div>
                )}

                {submitStatus === "error" && (
                  <div className="status-message error">
                    <span className="red-text">✗</span> Failed to send message.
                    Please try again.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>

        <MobileTopTabs />
        <Footer />
      </div>
    </>
  );
};

export default Contact;
